<template>
  <ContentLoader :speed="speed" viewBox="0 0 720 1971">
    <!-- 프로모션배너 -->
    <rect x="0" y="0" :rx="rx" :ry="ry" width="720" height="250" />

    <!-- 테마배너 제목 -->
    <rect x="32" y="280" :rx="rx" :ry="ry" width="656" height="49" />

    <!-- 테마배너 상품1 -->
    <rect x="35" y="365" :rx="rx" :ry="ry" width="203" height="203" />
    <rect x="35" y="586" :rx="rx" :ry="ry" width="203" height="15" />

    <!-- 테마배너 상품2 -->
    <rect x="258" y="365" :rx="rx" :ry="ry" width="203" height="203" />
    <rect x="258" y="586" :rx="rx" :ry="ry" width="203" height="15" />

    <!-- 테마배너 상품3 -->
    <rect x="482" y="365" :rx="rx" :ry="ry" width="203" height="203" />
    <rect x="482" y="586" :rx="rx" :ry="ry" width="203" height="15" />

    <!-- 테마배너 페이지 -->
    <rect x="340" y="633" :rx="rx" :ry="ry" width="40" height="22" />

    <!-- 베스트 상품 타이틀 -->
    <rect x="24" y="721" :rx="rx" :ry="ry" width="672" height="28" />

    <!-- 베스트 상품1 -->
    <rect x="24" y="772" :rx="rx" :ry="ry" width="322" height="455" />
    <rect x="24" y="1239" :rx="rx" :ry="ry" width="322" height="51" />

    <!-- 베스트 상품2 -->
    <rect x="372" y="772" :rx="rx" :ry="ry" width="322" height="455" />
    <rect x="372" y="1239" :rx="rx" :ry="ry" width="322" height="51" />

    <!-- 베스트 상품3 -->
    <rect x="24" y="1313" :rx="rx" :ry="ry" width="322" height="455" />
    <rect x="24" y="1780" :rx="rx" :ry="ry" width="322" height="51" />

    <!-- 베스트 상품4 -->
    <rect x="372" y="1313" :rx="rx" :ry="ry" width="322" height="455" />
    <rect x="372" y="1780" :rx="rx" :ry="ry" width="322" height="51" />

    <!-- 전체 상품 보기버튼 -->
    <rect x="24" y="1861" :rx="rx" :ry="ry" width="672" height="50" />
  </ContentLoader>
</template>

<script>
  import {defineComponent} from "vue";
  import { ContentLoader } from 'vue-content-loader'

  export default defineComponent({
    name: "content-placeholder-component",
    components: {
      ContentLoader,
    },
    data() {
      return {
        speed: 1,
        rx: 10,
        ry: 10,
      }
    }
  });
</script>

<style scoped>

</style>